import { useState } from "react";
import { fieldGroups } from "@/mocks/homeContent";

function HeatMeter({ level }: { level: number }) {
  return (
    <span className="inline-flex items-center gap-1" aria-label={`热度 ${level}/10`}>
      {Array.from({ length: 10 }).map((_, i) => (
        <span
          key={i}
          className={`h-1.5 w-1.5 rounded-full ${i < level ? "bg-accent-500" : "bg-background-200"}`}
        />
      ))}
    </span>
  );
}

export default function FieldsSection() {
  const [followed, setFollowed] = useState<boolean[]>(() => fieldGroups.map(() => false));

  const toggle = (i: number) => setFollowed((prev) => prev.map((v, idx) => (idx === i ? !v : v)));

  return (
    <section className="border-y border-background-200 bg-background-100/70">
      <div className="mx-auto w-full max-w-shell px-4 py-10 md:px-6 md:py-14">
        <div className="flex flex-wrap items-end justify-between gap-3">
          <div>
            <p className="text-xs font-medium uppercase tracking-[0.2em] text-secondary-700">SECTOR INDEX</p>
            <h2 className="mt-1 text-2xl font-black text-foreground-950 md:text-3xl">分领域 · 负面清单索引</h2>
            <p className="mt-2 text-sm text-foreground-500">按主题整理的爆料总集，标色点为单条热度。</p>
          </div>
          <button
            type="button"
            className="inline-flex items-center gap-1 whitespace-nowrap rounded-md bg-secondary-600 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-secondary-500"
          >
            <i className="ri-file-download-line text-base" aria-hidden="true"></i>
            下载本周清单 PDF
          </button>
        </div>

        <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {fieldGroups.map((group, idx) => (
            <article key={group.name} className="flex flex-col rounded-xl border border-background-200 bg-background-50 p-4 md:p-5">
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-3">
                  <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-800">
                    <i className={`${group.icon} text-xl`} aria-hidden="true"></i>
                  </span>
                  <div>
                    <h3 className="text-base font-bold text-foreground-950">{group.name}</h3>
                    <p className="text-xs text-foreground-500">{group.desc}</p>
                  </div>
                </div>
                <button
                  type="button"
                  onClick={() => toggle(idx)}
                  aria-pressed={followed[idx]}
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md transition-colors ${
                    followed[idx] ? "bg-accent-500 text-foreground-950" : "bg-background-100 text-foreground-600 hover:bg-background-200"
                  }`}
                >
                  <i className={`${followed[idx] ? "ri-notification-fill" : "ri-notification-line"} text-base`} aria-hidden="true"></i>
                </button>
              </div>

              <div className="mt-4 flex-1 divide-y divide-background-100">
                {group.entries.map((e) => (
                  <a key={e.title} href="#fields" className="group flex items-center gap-3 py-2.5">
                    <span className="min-w-0 flex-1 truncate text-sm text-foreground-800 group-hover:text-primary-700">
                      {e.title}
                    </span>
                    <span className="hidden shrink-0 text-[11px] text-foreground-400 md:block">{e.time}</span>
                    <HeatMeter level={e.level} />
                  </a>
                ))}
              </div>

              <a href="#fields" className="mt-3 inline-flex items-center gap-1 self-start text-sm font-medium text-primary-700 hover:text-primary-600">
                查看该分区归档
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}